import React, { useState, useContext } from 'react';
import css from './SendMessageModal.module.css'
import { AppContext } from '../../../../providers/appProvider';
 import Modal from '../../../UI/Modal/Modal';
import Comment from '../../../../assets/Icon/Comment';
import { useTranslation } from 'react-i18next';


const SendMessageModal = ({ messageService, mobile }) => {
  const {t} = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { appState, app } = useContext(AppContext);
  
  const [text, setText] = useState("");
  const [mob, setMob] = useState(mobile);

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleChangeButtonClick = () => {
    messageService.add(mob, text)
      .then((response) => {
        setIsModalOpen(false)
      })
      .catch((error) => {
        app.setError("შეცდომა")
      });
  };

  const openDelete = () => {
    setIsModalOpen(true)
  }

  const closeDelete = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      <span className={css.btn} onClick={() => openDelete()} >
        <Comment /> SMS
      </span>

      <Modal key={mobile} size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>
        <div>

          <div className={css.modalHead} >
            <h3>
              <span className={css.iconHead} > <Comment/></span>
              {t('Message')}
            </h3>
          </div>

          <textarea
            placeholder={t('Message')}
            value={text}
            onChange={handleTextChange}
            rows="14"
            cols="55"
            className={css.customtextarea}
          ></textarea>
 
          <span onClick={handleChangeButtonClick} style={{ marginLeft: 'auto' }} className={css.btnPrimary}>{t('Send')}</span>


        </div>
      </Modal>
    </div>
  );
};

export default SendMessageModal;